import { createActions } from 'redux-actions';

export const { changeFilterOpen, changeFilter, resetAllFilters } = createActions(
  {},
  'CHANGE_FILTER_OPEN',
  'CHANGE_FILTER',
  'RESET_ALL_FILTERS'
);
